<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="bleeding-red">
<h1>Bleeding Red</h1>
<p style="text-indent:0px;">It is said that African soil is so red,</p>
<p style="text-indent:0px;">From all the battles of civil war.</p>
<p style="text-indent:0px;">It is stained from all the bloodshed,</p>
<p style="text-indent:0px;">Its heart ripped from its core.</p><br/>
<p style="text-indent:0px;">African beauty cannot be explained,</p>
<p style="text-indent:0px;">The sun, the bush and sea.</p>
<p style="text-indent:0px;">Its blood runs through our veins,</p>
<p style="text-indent:0px;">Calling you back it will always be.</p><br/>
<p style="text-indent:0px;">The African wind is now weeping,</p>
<p style="text-indent:0px;">The animals are being murdered.</p>
<p style="text-indent:0px;">The silver lining disappearing,</p>
<p style="text-indent:0px;">Its people being slaughtered.</p><br/>
<p style="text-indent:0px;">An African elephant named,</p>
<p style="text-indent:0px;">By the shape of her continental ear.</p>
<p style="text-indent:0px;">Wildlife roam free and untamed,</p>
<p style="text-indent:0px;">Not for long, as they slowly disappear.</p><br/>
<p style="text-indent:0px;">The pain she feels as man has neglected,</p>
<p style="text-indent:0px;">The generosity of her lands.</p>
<p style="text-indent:0px;">She is a gentle soul being rejected,</p>
<p style="text-indent:0px;">By the greed of outstretched hands.</p><br/>
<p style="text-indent:0px;">There is hope for her future generations,</p>
<p style="text-indent:0px;">Our children can hear a lion’s roar!</p>
<p style="text-indent:0px;">Only if we start now with preparations,</p>
<p style="text-indent:0px;">Stitching back what we have tore.</p><br/>
<p style="text-indent:0px;">Understanding the African lure,</p>
<p style="text-indent:0px;">Can only be felt by those born there.</p>
<p style="text-indent:0px;">It is wild, perfect, pure,</p>
<p style="text-indent:0px;">Although it seems that some don’t care.</p><br/>
<p style="text-indent:0px;">I fear for Africa, divided by poverty,</p>
<p style="text-indent:0px;">Made possible by her political leaders.</p>
<p style="text-indent:0px;">There is no longer solidarity,</p>
<p style="text-indent:0px;">Between the battling soldiers.</p><br/>
<p style="text-indent:0px;">Africa quivers as war rages on,</p>
<p style="text-indent:0px;">Unnecessary hate in the breeze.</p>
<p style="text-indent:0px;">Her tears continue to rain upon,</p>
<p style="text-indent:0px;">Her ground that is red, it still bleeds!</p>
<p style="text-indent:0px;"><strong><br/>
</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch011.vue?69bf0890